<template>
  <div class="ma-3" v-if="device.isReady()">
    <div v-if="device.state" class="ma-2">
      <v-row class="mt-3"><h5 class="text--disabled">Device Info</h5></v-row>
      <v-row><v-divider /></v-row>
      <v-row>
        <videon-state-tile
          heading="Device Name"
        >
          {{ device.deviceName() }}
        </videon-state-tile>
        <videon-state-tile
          heading="Platform"
        >
          <product-label :device="device"/>
        </videon-state-tile>
        <videon-state-tile
          heading="Serial Number"
        >
          {{ device.state.serial_number }}
        </videon-state-tile>
        
        <videon-state-tile
          heading="Manufacture Date"
          class="secondary--text"
          v-if="isAdmin && device.manufacture_date"
        >
          {{ device.manufacture_date }}
        </videon-state-tile>
        
        <videon-state-tile
          heading="MAC Address"
        >
          {{ device.state.mac_address_current }}
        </videon-state-tile>
        
        <videon-state-tile
          heading="Last Boot"
        >
          {{ device.state.last_boot | moment("YYYY/MM/DD hh:mm:ss a") }}
        </videon-state-tile>
        <videon-state-tile
          heading="Device Uptime"
        >
          {{ uptime }}
        </videon-state-tile>
        
        
        <videon-state-tile
          heading="Last State Update"
        >
          {{ device.state.last_state_update | moment("YYYY/MM/DD hh:mm:ss a") }}
        </videon-state-tile>
      </v-row>
      
      <v-row><h5 class="text--disabled">Device State</h5></v-row>
      <v-row><v-divider /></v-row>
      <v-row>
        <videon-state-tile
          heading="Device Online"
          class="text-capitalize"
        >
          <span 
            :class="(!device.isOnline()) ? 'error--text' : ''"
          >
            {{ device.isOnline() }}
          </span>
        </videon-state-tile>
        <videon-state-tile
          heading="Ready For Commands"
          class="text-capitalize"
        >
          <span 
            :class="(!device.state.ready_for_commands) ? 'error--text' : ''"
          >
            {{ device.state.ready_for_commands }}
          </span>
        </videon-state-tile>
        <videon-state-tile
          heading="Config Ready"
          class="text-capitalize"
        >
          <span
            :class="(!device.configReadyDisplay()) ? 'error--text' : ''"
          >
            {{ device.configReadyDisplay() }}
          </span>
        </videon-state-tile>
        <videon-state-tile
          heading="Internal IP"
        >
          {{ device.deviceIP() }}
          <span v-if="device.IPScheme() == 'dhcp'" class="font-weight-thin">(DHCP)</span>
        </videon-state-tile>
        <videon-state-tile
          heading="External IP"
        >
          {{ externalIP }}
        </videon-state-tile>
        
        <videon-state-tile
          heading="Decoder State"
          v-if="device.state.decoder_info"
        >
          <bird-dog-debug :device="device" />
        </videon-state-tile>
      </v-row>

      <device-fleets-section :device_guid="device_guid" />
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import moment from 'moment'
  import DeviceFleetsSection from './DeviceFleetsSection.vue'
  
  export default {
    name: 'DecoderInfo',
    components: {
      DeviceFleetsSection,
    },
    
    props: ['device_guid', 'device'],
    
    computed: {
      ...mapGetters('user', ['user', 'guid', 'isAdmin', 'isDeviceAdmin', 'organization']),
      
      externalIP() {
        if (this.device && this.device.external_ip) {
          return this.device.external_ip
        }
        return 'Unknown'
      },
      
      uptime() {
        if (!this.device.isOnline()) {
          return 'Offline'
        } else if (this.device && this.device.state) {
          if (this.device.state.last_boot && this.device.last_api_request_id) {
            return moment(this.device.state.last_boot).fromNow(true)
          }
        }
        return 'Unknown'
      },
    }
  }
</script>